import { useQuery } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { genealogyKeys } from '../queries/keys';
import { genealogyPaths } from '../queries/paths';

// TSS vite/03 — genealogía de un animal (admin-genealogy.md). Árbol ancestral en
// cascada (recursive CTE), acotado por `depth` (def 10, máx 20). Permiso genealogies:read.
// Los nodos ya expandidos reaparecen con `ref:true`; los ciclos los corta el backend.
export function useGenealogy(animalId, depth) {
    return useQuery({
        queryKey: genealogyKeys.tree(animalId, depth),
        queryFn:  ({ signal }) => api.get(genealogyPaths.tree(animalId), { params: { depth }, signal }).then(r => r.data),
        enabled:  !!animalId,
        placeholderData: (prev) => prev,
    });
}
